const DEFAULT_TIMEOUT = 30000; // 30 secondi
const MAX_RETRIES = 3;
const INITIAL_DELAY = 1000; // 1 secondo

export const retryWithBackoff = async (
  operation,
  maxRetries = MAX_RETRIES,
  initialDelay = INITIAL_DELAY
) => {
  let lastError;
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      // Imposta un timeout per l'operazione
      const result = await Promise.race([
        operation(),
        new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Operation timeout')), DEFAULT_TIMEOUT)
        )
      ]);
      
      return result;
    } catch (error) {
      lastError = error;
      console.warn(`Attempt ${i + 1} failed:`, error);
      
      if (i < maxRetries - 1) {
        // Calcola il delay con backoff esponenziale
        const delay = initialDelay * Math.pow(2, i);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }
  
  throw lastError;
}; 